const nav = document.querySelector(".header__menu");
const navBtn = document.querySelector(".header__list-button");
const navBtnImg = document.querySelector(".header__list-button-img");

navBtn.onclick = () => {
  if (nav.classList.toggle("active")) {
    navBtnImg.src = "https://cdn.shopify.com/s/files/1/0625/5306/3559/files/burgerclose.svg?v=1731687040";
  } else {
    navBtnImg.src = "https://cdn.shopify.com/s/files/1/0625/5306/3559/files/burgeropen.svg?v=1731687034g";
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const heroSwiper = new Swiper('.hero-swiper-container', {
    loop: true,
    effect: "fade",
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'progressbar',
    },
    on: {
      slideChange: function () {
        const activeSlide = this.slides[this.activeIndex];
        // const newText = activeSlide.getAttribute('data-text');
        // const newLink = activeSlide.getAttribute('data-link');
        
        const paginationWrapper = document.querySelector('.swiper-pagination-wrapper');
        // paginationWrapper.setAttribute('data-content', `Learn more about ${newText}`);
        // paginationWrapper.setAttribute('data-link', newLink);
      },
    },
  });

  // Set initial "Learn more" text and link
  const initialSlide = document.querySelector('.swiper-slide[data-text]');
  const paginationWrapper = document.querySelector('.swiper-pagination-wrapper');
  // paginationWrapper.setAttribute('data-content', `Learn more about ${initialSlide.getAttribute('data-text')}`);
  // paginationWrapper.setAttribute('data-link', initialSlide.getAttribute('data-link'));

  // Add click event to "Learn more" text
  paginationWrapper.addEventListener('click', (event) => {
    // Ensure only the "Learn more" text is clickable
    if (event.target === paginationWrapper) {
      const link = paginationWrapper.getAttribute('data-link');
      if (link) {
        window.location.href = link;
      }
    }
  });

  // Prevent clicks on navigation buttons or pagination from triggering the link
  const navButtons = document.querySelectorAll('.swiper-button-next, .swiper-button-prev, .swiper-pagination');
  navButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  });
});






  const reviewHeader = document.querySelector(".mpr__wrapper-review-heading");
  const reviewBlock = document.querySelector(".mpr__wrapper-review-main");
  const headingText = document.querySelector(".mpr-reviews-heading-text");
  const reviewsNumber = document.querySelector(".mpr-reviews-number");
  const starsPurple = document.querySelector(".stars__purple");
  const reviewSvgPath = document.querySelector(".mpr-review-svg path");

  let isToggled = false;

if (reviewHeader) {
  reviewHeader.addEventListener("click", () => {
    isToggled = !isToggled;

    const color = isToggled ? "#050415" : "#49397E";
    reviewBlock.style.display = isToggled ? "none" : "block";
    headingText.style.color = reviewsNumber.style.color = color;
    if (starsPurple)
      starsPurple.src = isToggled
        ? "https://cdn.shopify.com/s/files/1/0625/5306/3559/files/stars.png?v=1730910457"
        : "https://cdn.shopify.com/s/files/1/0625/5306/3559/files/starspurple.png?v=1733173384";
    if (reviewSvgPath) reviewSvgPath.setAttribute("fill", color);
    document.querySelector(".mpr-review-svg").style.transform = isToggled
      ? "rotate(180deg)"
      : "rotate(0deg)";
  });
    
}


if (document.querySelector(".gallery-thumbs") && document.querySelector(".gallery-top")) {
  const galleryThumbs = new Swiper(".gallery-thumbs", {
    spaceBetween: 10,
    slidesPerView: "3",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    loop: false,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    grabCursor: true,
  });

  const galleryTop = new Swiper(".gallery-top", {
    effect: "fade",
    fadeEffect: { crossFade: true },
    slidesPerView: "1",
    loop: false,
    thumbs: {
      swiper: galleryThumbs,
    },
  });

  const variantItems = document.querySelectorAll('.variant-item');
    variantItems.forEach(item => {
      item.addEventListener('click', () => {
        const index = parseInt(item.getAttribute('data-index'), 10);
        galleryTop.slideTo(index - 1);

        variantItems.forEach(el => el.classList.remove('active'));
        item.classList.add('active');
      });
    });
}


// if(document.querySelector('.hero-swiper-container')) {
//   const heroSwiper = new Swiper('.hero-swiper-container', {
//       loop: true,
//       effect: "fade",
//       navigation: {
//         nextEl: '.swiper-button-next', 
//         prevEl: '.swiper-button-prev', 
//       },
//       pagination: {
//         el: '.swiper-pagination', 
//         clickable: true,
//         type: 'progressbar', 
//       },
//     });
// }


function onSubmit() {
  document.getElementById('cart-submit').click();
}


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product__hide').forEach(div => div.style.display = 'none');
  document.querySelectorAll('.search__blog-heading, .search__product-heading, .search__industry-heading').forEach(heading => {
    heading.style.color = '#6D7075';
    heading.style.transition = 'color 0.3s ease';
    heading.addEventListener('click', () => {
      const hiddenDiv = heading.parentElement.querySelector('.product__hide');
      if (hiddenDiv) {
        const isVisible = hiddenDiv.style.display === 'flex';
        hiddenDiv.style.display = isVisible ? 'none' : 'flex';
        heading.style.color = isVisible ? '#6D7075' : '#000000';
      }
    });
  });
});


if (document.querySelector('.mpr-quanity__inner')) {
    const quantityInput = document.querySelector('.input-number');
    const decrementBtn = document.querySelector('.mpr-btn-minus');
    const incrementBtn = document.querySelector('.mpr-btn-plus');
    const maxQuantity = 9;


    decrementBtn.addEventListener('click', (event) => {
        event.preventDefault();
        let currentValue = parseInt(quantityInput.value) || 1;
        if (currentValue > 1) {
            quantityInput.value = currentValue - 1;
        }
    });


    incrementBtn.addEventListener('click', (event) => {
        event.preventDefault();
        let currentValue = parseInt(quantityInput.value) || 1;
        if (currentValue < maxQuantity) {
            quantityInput.value = currentValue + 1;
        }
    });

    quantityInput.addEventListener('input', () => {
        let currentValue = parseInt(quantityInput.value) || 1;
        if (currentValue > maxQuantity) {
            quantityInput.value = maxQuantity;
        } else if (currentValue < 1) {
            quantityInput.value = 1;
        }
    });
}


if (document.querySelectorAll('.viewcart__card').length) {
    const maxQuantity = 9;

    document.querySelectorAll('.viewcart__card').forEach(card => {
        const quantityInput = card.querySelector('.viewcart-quantity-input');
        const decrementBtn = card.querySelector('.viewcart-btn-minus');
        const incrementBtn = card.querySelector('.viewcart-btn-plus');

        decrementBtn.addEventListener('click', () => {
            let currentValue = parseInt(quantityInput.value) || 1;
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
                document.querySelector(".viewcart__form").submit();
            }
        });

        incrementBtn.addEventListener('click', () => {
            let currentValue = parseInt(quantityInput.value) || 1;
            if (currentValue < maxQuantity) {
                quantityInput.value = currentValue + 1;
                document.querySelector(".viewcart__form").submit();
            }
        });

        quantityInput.addEventListener('input', () => {
            let currentValue = parseInt(quantityInput.value) || 1;
            if (currentValue > maxQuantity) {
                quantityInput.value = maxQuantity;
            } else if (currentValue < 1) {
                quantityInput.value = 1;
            }
        });
    });
}
 document.addEventListener('DOMContentLoaded', () => {
  const ipInner = document.querySelector('.ip-inner');
  const hiddenForm = document.querySelector('.hidden-form');

  if (ipInner && hiddenForm) {
    ipInner.addEventListener('click', () => {
      hiddenForm.classList.toggle('show');
    });
  }
});


document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.startsWith('/collections/')) {
    var paginationLinks = document.querySelectorAll('.pagination-link');

    paginationLinks.forEach(function(link) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        var url = this.href;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function() {
          window.location.href = url;
        }, 300);
      });
    });
  }
});

